import { Button, Chip, Divider, Grid, Modal, Paper, TextField, useTheme } from "@mui/material";
import { ProjectVendorHeader } from "./PurchaseOrder";
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import { Fragment, useEffect, useState } from "react";
import PurchaseOrder from "./PurchaseOrder";
import PurchaseOrderPopup from "./PurchaseOrderPopup";
import { selectEditingPurchaseOrder, setEditingPurchaseOrder } from "@/actuals/actualSlice";
import { useSelector } from "react-redux";
import { CustomBox } from "@/common/StyledComponents";
import { request } from "@/Api";
import { useDispatch } from "react-redux";

export default function PurchaseOrders({variant, purchaseOrders, editable, onAdd, onUpdate, onDelete, onInvite}){
    const [ popupOpen, setPopupOpen ] = useState(false)
    const projectVariant = variant == "project"

    const handleAddVendorButton = () => {
        setPopupOpen(true)
    }

    return (
        <div style={{overflow: "auto"}}>
            <Grid container justifyContent={"space-between"} alignItems={"center"} paddingBottom={5}>
                <Grid item>
                    <h4>Purchase Orders</h4>
                </Grid>
                <Grid item>
                    <Grid container spacing={2}>
                        <Grid item>
                            {editable ? 

                                projectVariant ? 
                                <Chip clickable onClick={handleAddVendorButton} variant='outlined' sx={{padding: 1}} label="Add Vendor" icon={<PersonAddOutlinedIcon />} />
                                :
                                <Button onClick={handleAddVendorButton} variant="contained" startIcon={<PersonAddOutlinedIcon />}>
                                    Add Vendor
                                </Button> : 
                                <Chip label="Please upload a signed bid to add vendors to this project." disabled/> 
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <ProjectVendorHeader variant={variant}/>
            {purchaseOrders.map(po=>
               <Fragment key={po.id}>
                    <PurchaseOrder variant={variant} purchaseOrder={po} onDelete={onDelete} onUpdate={onUpdate} onInvite={onInvite}/>
                    <Divider />
                </Fragment>
            )}
            {purchaseOrders.length == 0 &&                  
                <Paper sx={{textAlign: "center", boxShadow: "none", padding: 4}}>
                    <span style={{fontSize: 14, color: "gray"}}>No purchase orders</span>
                </Paper>
            }
            <PurchaseOrderPopup 
                isOpen={popupOpen}
                handleClose={()=>{setPopupOpen(false)}}
                onAdd={onAdd}
            />
            <PurchaseOrderEditPopup onUpdate={onUpdate}/>
        </div>
    )
}

const PurchaseOrderEditPopup = ({onUpdate}) => {
    const theme = useTheme()
    const dispatch = useDispatch()
    const editingPurchaseOrder = useSelector(selectEditingPurchaseOrder)
    const [purchaseOrder, setPurchaseOrder] = useState(editingPurchaseOrder)
    const handleClose = () => {
        dispatch(setEditingPurchaseOrder(null))
    }
    const handleInput = (field) => (event) => {
        setPurchaseOrder({...purchaseOrder, [field]: event.target.value})
    }
    const handleEdit = () => {
        request.patch(`purchase-orders/${purchaseOrder.id}`, purchaseOrder)
        .then(response=>{
            dispatch(setEditingPurchaseOrder(null))
            onUpdate && onUpdate(response.data)
        })
    }
    useEffect(()=>{
        setPurchaseOrder(editingPurchaseOrder)
    }, [editingPurchaseOrder])
    if (!purchaseOrder){
        return null
    }
    return (
        <Modal open={editingPurchaseOrder != null} onClose={handleClose}>
            <CustomBox sx={{ 
                maxHeight: "90vh",
                padding: 2,
                paddingLeft: 4,
                paddingRight: 4,
                background: theme.palette.background.default, 
                overflow: "scroll",
                width: "60%",
                minWidth: 800
            }}>
                <h3 style={{marginBottom: 15}}>Edit Purchase Order</h3>
                <TextField 
                    type="number"
                    label="Amount"
                    value={purchaseOrder.amount}
                    onChange={handleInput("amount")}
                    fullWidth
                    margin="normal"
                    sx={{marginBottom: 4}}
                    inputProps={{style: {textAlign: "right"}}}
                    InputProps={{startAdornment: <span>{purchaseOrder.vendor && purchaseOrder.vendor.payment_currency}</span>}}
                />
                <div style={{textAlign: "right"}}>
                    <Button onClick={handleEdit} variant="contained">Confirm</Button>
                </div>
            </CustomBox>
        </Modal>
    )
}